import { Controller } from "react-hook-form";
import {
  Select,
  MenuItem,
  TextField,
  ListSubheader,
  InputAdornment,
  Checkbox,
  ListItemText,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useState, useRef, useEffect } from "react";

const MultiSelectSearch = ({
  control,
  name,
  data,
  optionKey = "id",
  optionLabel = "name",
  noDefault = false,
  isReadOnly = false,
  setValue, // pass setValue from useForm
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const searchRef = useRef(null);

  const filteredData = data?.filter((item) =>
    item?.[optionLabel]?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      searchRef.current?.focus();
    }, 100);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={[]}
      render={({ field }) => (
        <Select
          {...field}
          multiple
          fullWidth
          size="small"
          disabled={isReadOnly}
          displayEmpty
          value={field.value || []}
          onChange={(e) => {
            const value = e.target.value;
            setValue(name, value, {
              shouldValidate: true,
              shouldDirty: true,
            });
            setSearchTerm("");
          }}
          renderValue={(selected) =>
            data
              .filter((item) => selected.includes(item?.[optionKey]))
              .map((item) => item?.[optionLabel])
              .join(", ")
          }
          MenuProps={{
            PaperProps: {
              style: { maxHeight: 300 },
              onKeyDown: (e) => e.stopPropagation(),
            },
          }}
        >
          <ListSubheader>
            <TextField
              size="small"
              placeholder="Search"
              fullWidth
              inputRef={searchRef}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyDown={(e) => e.stopPropagation()}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
            />
          </ListSubheader>

          {!noDefault && (
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
          )}

          {filteredData?.map((item, index) => {
            const key = item?.[optionKey];
            const label = item?.[optionLabel];
            return (
              <MenuItem key={index} value={key}>
                <Checkbox checked={field.value?.includes(key)} />
                <ListItemText primary={label} />
              </MenuItem>
            );
          })}

          {filteredData?.length === 0 && (
            <MenuItem disabled>
              <em>No results found</em>
            </MenuItem>
          )}
        </Select>
      )}
    />
  );
};

export default MultiSelectSearch;
